/**
 * @flow
 * @relayHash e8d43b953877717460a2aa51c43fadba
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getEnrollmentQueryVariables = {|
  enrollmentId: string
|};
export type getEnrollmentQueryResponse = {|
  +enrollment: {|
    +id: string,
    +email: string,
    +referralLink: ?string,
    +inviteEmailUrl: ?string,
  |}
|};
export type getEnrollmentQuery = {|
  variables: getEnrollmentQueryVariables,
  response: getEnrollmentQueryResponse,
|};
*/


/*
query getEnrollmentQuery(
  $enrollmentId: ID!
) {
  enrollment(enrollmentId: $enrollmentId) {
    id
    email
    referralLink
    inviteEmailUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "enrollmentId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "enrollment",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enrollmentId",
        "variableName": "enrollmentId"
      }
    ],
    "concreteType": "HyreferralEnrollment",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "referralLink",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "inviteEmailUrl",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getEnrollmentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getEnrollmentQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getEnrollmentQuery",
    "id": null,
    "text": "query getEnrollmentQuery(\n  $enrollmentId: ID!\n) {\n  enrollment(enrollmentId: $enrollmentId) {\n    id\n    email\n    referralLink\n    inviteEmailUrl\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '20a14a3db1472f3f24d125ff263b80aa';
module.exports = node;
